﻿let metro = [
    // Branch 1 - Red:
    { branch: 1, order: 0, color: "#FC0D1B", station: 'Девяткино' },
    { branch: 1, order: 1, color: "#FC0D1B", station: 'Автово' },
    { branch: 1, order: 2, color: "#FC0D1B", station: 'Гражданский проспект' },
    { branch: 1, order: 3, color: "#FC0D1B", station: 'Академическая' },
    { branch: 1, order: 4, color: "#FC0D1B", station: 'Политехническая' },
    { branch: 1, order: 5, color: "#FC0D1B", station: 'Площадь Мужества' },
    { branch: 1, order: 6, color: "#FC0D1B", station: 'Лесная' },
    { branch: 1, order: 7, color: "#FC0D1B", station: 'Выборгская' },
    { branch: 1, order: 8, color: "#FC0D1B", station: 'Площадь Ленина' },
    { branch: 1, order: 9, color: "#FC0D1B", station: 'Чернышевская' },
    { branch: 1, order: 10, color: "#FC0D1B", station: 'Площадь Восстания' },
    { branch: 1, order: 11, color: "#FC0D1B", station: 'Владимирская' },
    { branch: 1, order: 12, color: "#FC0D1B", station: 'Пушкинская' },
    { branch: 1, order: 13, color: "#FC0D1B", station: 'Технологический институт 1' },
    { branch: 1, order: 14, color: "#FC0D1B", station: 'Балтийская' },
    { branch: 1, order: 15, color: "#FC0D1B", station: 'Нарвская' },
    { branch: 1, order: 16, color: "#FC0D1B", station: 'Кировский завод' },
    { branch: 1, order: 17, color: "#FC0D1B", station: 'Ленинский проспект' },
    { branch: 1, order: 18, color: "#FC0D1B", station: 'Проспект Ветеранов' },


    // Branch 2 - Blue:
    { branch: 2, order: 0, color: '#007DCC', station: 'Парнас' },
    { branch: 2, order: 1, color: '#007DCC', station: 'Проспект Просвещения' },
    { branch: 2, order: 2, color: '#007DCC', station: 'Озерки' },
    { branch: 2, order: 3, color: '#007DCC', station: 'Удельная' },
    { branch: 2, order: 4, color: '#007DCC', station: 'Пионерская' },
    { branch: 2, order: 5, color: '#007DCC', station: 'Чёрная речка' },
    { branch: 2, order: 6, color: '#007DCC', station: 'Петроградская' },
    { branch: 2, order: 7, color: '#007DCC', station: 'Горьковская' },
    { branch: 2, order: 8, color: '#007DCC', station: 'Невский проспект' },
    { branch: 2, order: 9, color: '#007DCC', station: 'Сенная площадь' },
    { branch: 2, order: 10, color: '#007DCC', station: 'Технологический институт 2' },
    { branch: 2, order: 11, color: '#007DCC', station: 'Фрунзенская' },
    { branch: 2, order: 12, color: '#007DCC', station: 'Московские ворота' },
    { branch: 2, order: 13, color: '#007DCC', station: 'Электросила' },
    { branch: 2, order: 14, color: '#007DCC', station: 'Парк Победы' },
    { branch: 2, order: 15, color: '#007DCC', station: 'Московская' },
    { branch: 2, order: 16, color: '#007DCC', station: 'Звёздная' },
    { branch: 2, order: 17, color: '#007DCC', station: 'Купчино' },

    // Branch 3 - Green
    { branch: 3, order: 0, color: '#0F7F12', station: 'Беговая' },
    { branch: 3, order: 1, color: '#0F7F12', station: 'Новокрестовская' },
    { branch: 3, order: 2, color: '#0F7F12', station: 'Приморская' },
    { branch: 3, order: 3, color: '#0F7F12', station: 'Василеостровская' },
    { branch: 3, order: 4, color: '#0F7F12', station: 'Гостиный двор' },
    { branch: 3, order: 5, color: '#0F7F12', station: 'Маяковская' },
    { branch: 3, order: 6, color: '#0F7F12', station: 'Площадь Александра Невского 1' },
    { branch: 3, order: 7, color: '#0F7F12', station: 'Елизаровская' },
    { branch: 3, order: 8, color: '#0F7F12', station: 'Ломоносовская' },
    { branch: 3, order: 9, color: '#0F7F12', station: 'Пролетарская' },
    { branch: 3, order: 10, color: '#0F7F12', station: 'Обухово' },
    { branch: 3, order: 11, color: '#0F7F12', station: 'Рыбацкое' },

    // Branch 4 - Orange
    { branch: 4, order: 0, color: '#DE7008', station: 'Спасская' },
    { branch: 4, order: 1, color: '#DE7008', station: 'Достоевская' },
    { branch: 4, order: 2, color: '#DE7008', station: 'Лиговский проспект' },
    { branch: 4, order: 3, color: '#DE7008', station: 'Площадь Александра Невского 2' },
    { branch: 4, order: 4, color: '#DE7008', station: 'Новочеркасская' },
    { branch: 4, order: 5, color: '#DE7008', station: 'Ладожская' },
    { branch: 4, order: 6, color: '#DE7008', station: 'Проспект Большевиков' },
    { branch: 4, order: 7, color: '#DE7008', station: 'Улица Дыбенко' },

    // Branch 5 - Purple
    { branch: 5, order: 0, color: '#7F0F7E', station: 'Комендантский проспект' },
    { branch: 5, order: 1, color: '#7F0F7E', station: 'Старая Деревня' },
    { branch: 5, order: 2, color: '#7F0F7E', station: 'Крестовский остров' },
    { branch: 5, order: 3, color: '#7F0F7E', station: 'Чкаловская' },
    { branch: 5, order: 4, color: '#7F0F7E', station: 'Спортивная' },
    { branch: 5, order: 5, color: '#7F0F7E', station: 'Адмиралтейская' },
    { branch: 5, order: 6, color: '#7F0F7E', station: 'Садовая' },
    { branch: 5, order: 7, color: '#7F0F7E', station: 'Звенигородская' },
    { branch: 5, order: 8, color: '#7F0F7E', station: 'Обводный канал' },
    { branch: 5, order: 9, color: '#7F0F7E', station: 'Волковская' },
    { branch: 5, order: 10, color: '#7F0F7E', station: 'Бухарестская' },
    { branch: 5, order: 11, color: '#7F0F7E', station: 'Международная' },
    { branch: 5, order: 12, color: '#7F0F7E', station: 'Проспект славы' },
    { branch: 5, order: 13, color: '#7F0F7E', station: 'Дунайская' },
    { branch: 5, order: 14, color: '#7F0F7E', station: 'Шушары' },
];

export default metro;

